import carrierAccountsSaga from '~/sagas/carrier-accounts/carrier-accounts.saga';

export default carrierAccountsSaga;
